import { render } from "./DashboardPublicAddress.vue?vue&type=template&id=55427923&scoped=true&ts=true"
import script from "./DashboardPublicAddress.vue?vue&type=script&lang=ts"
export * from "./DashboardPublicAddress.vue?vue&type=script&lang=ts"

import "./DashboardPublicAddress.vue?vue&type=style&index=0&id=55427923&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55427923"]])

export default __exports__